import { render, staticRenderFns } from "./SearchboxV2.vue?vue&type=template&id=3e40a9d4&scoped=true&"
import script from "./SearchboxV2.vue?vue&type=script&lang=ts&"
export * from "./SearchboxV2.vue?vue&type=script&lang=ts&"
import style0 from "./SearchboxV2.vue?vue&type=style&index=0&id=3e40a9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40a9d4",
  null
  
)

export default component.exports